"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(toastSaga),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(handleShowToast),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(handleHideToast);

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toastSaga = void 0;

var effects_1 = require("redux-saga/effects");

var actions_1 = require("./actions");

var selectors_1 = require("./selectors");

var cache = __importStar(require("./cache"));

function toastSaga() {
  return _regeneratorRuntime.wrap(function toastSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return effects_1.takeEvery(actions_1.SHOW_TOAST, handleShowToast);

        case 2:
          _context.next = 4;
          return effects_1.takeEvery(actions_1.HIDE_TOAST, handleHideToast);

        case 4:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

exports.toastSaga = toastSaga;

function handleShowToast(action) {
  var toast, ids, lastId, id;
  return _regeneratorRuntime.wrap(function handleShowToast$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          toast = action.payload.toast;
          _context2.next = 3;
          return effects_1.select(selectors_1.getState);

        case 3:
          ids = _context2.sent;
          lastId = Number(ids[ids.length - 1] || 0);
          id = lastId + 1;
          cache.set(id, toast);
          _context2.next = 9;
          return effects_1.put(actions_1.renderToast(id));

        case 9:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function handleHideToast(action) {
  var id;
  return _regeneratorRuntime.wrap(function handleHideToast$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          id = action.payload.id;
          cache.remove(id);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}